import httpService from './httpService';
import queryString from 'query-string';
import { formatDate } from '@progress/kendo-intl';
import { IAcceptedAgreements } from './types/IAcceptedAgreements';

export const verifyUser = (): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Users/verify`);
  return httpService
    .get(endpoint)
    .then((response) => {
      if (response.status === 200) return response.data;
      return null;
    })
    .catch((err) => {
      console.log('error getting endpoint ', err);
      return null;
    });
};

export const getProfile = (): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Users/profile`);
  return httpService.get(endpoint);
};

export const getActivity = (): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Users/activity`);
  return httpService.get(endpoint);
};

export const getImpersonate = (impersonatorName?): Promise<any> => {
  let endpoint;
  if (impersonatorName) {
    endpoint = httpService.getEndpointURL(`/Users/available/to/impersonate?name=${impersonatorName}`);
  } else {
    endpoint = httpService.getEndpointURL(`/Users/available/to/impersonate`);
  }
  return httpService.getTyped<any>(endpoint);
};

export const canImpersonate = (): Promise<any> => {
  let endpoint;
  endpoint = httpService.getEndpointURL(`/Users/can/impersonate`);
  return httpService.get(endpoint).then((r) => r.status === 200).catch(() => false);
};

export const saveUserSettings = (slicerTooltip): Promise<any> => {
  let endpoint = httpService.getEndpointURL(`/Users/settings`);
  return httpService.put(endpoint, slicerTooltip);
};

export const getUserSettings = () => {
  return verifyUser().then((res) => res.settings);
};

export const getUserActivityFeed = (
  type,
  documentName,
  funds,
  investors,
  classifications,
  activityFeedFromDate,
  startResult,
  maxResults,
  sortField,
  sortDir,
  includeCount,
): Promise<any> => {
  let parsedQuery = queryString.parse(location.search);

  if (type) {
    parsedQuery.type = type;
  }
  if (documentName) {
    parsedQuery.name = documentName;
  }
  if (funds && funds.length > 0) {
    parsedQuery.funds = funds.map((x) => x.id);
  }
  if (investors && investors.length > 0) {
    parsedQuery.investors = investors.map((x) => x.objectId);
  }
  if (classifications && classifications.length > 0) {
    parsedQuery.classifications = classifications.map((x) => x.id);
  }

  if (activityFeedFromDate) {
    const today = new Date();
    const startDate = activityFeedFromDate === 0 || activityFeedFromDate === null ? null : new Date(new Date().setDate(today.getDate() - activityFeedFromDate));
    parsedQuery.startDate = formatDate(startDate, 'yyyy-MM-dd');
  }
  if (startResult) {
    parsedQuery.startResult = startResult;
  }
  if (maxResults) {
    parsedQuery.maxResults = maxResults;
  }
  if (sortField) {
    parsedQuery.sortField = sortField;
  }
  if (sortDir) {
    parsedQuery.sortDir = sortDir;
  }

  parsedQuery.includeTotalCount = includeCount;

  const stringified = queryString.stringify(parsedQuery);

  let endpoint = httpService.getEndpointURL(`/Users/feed?${stringified}`);
  return httpService.getTyped<any>(endpoint);
};

export const getAcceptedAgreements = (): Promise<IAcceptedAgreements[]> => {
  let endpoint = httpService.getEndpointURL(`/Users/agreements/accepted`);
  return httpService.getTyped<IAcceptedAgreements[]>(endpoint);
};
